import * as Api from '@/api/index';
import axios from 'axios';

export const updateAlert = async payload => {
    try {
        const { code, ...params } = payload;
        if (!code || !params.st) {
            return { status: 'error', message: 'Invalid Request' };
        }

        const url = Api.getv2ApiBase(`/alerts/code/${code}`);
        const options = Api.getOptions();

        return await axios.post(url, { ...params }, options);
    } catch (error) {
        const errorMessage =
            error && error.response && error.response.data ? error.response.data.message : '';
        return { status: 'error', message: errorMessage };
    }
};

export const getAlertContextAndUpdateTimedValue = async ({
    code,
    st,
    pageload,
    isUserLoggedIn
}) => {
    try {
        if (!code || !st) {
            return { status: 'error', message: 'Invalid Request' };
        }

        const url = Api.getv2ApiBase(
            `/alerts/${code}?st=${st}&pageload=${pageload}&auth=${isUserLoggedIn}`
        );
        const options = Api.getOptions();

        const response = await axios.put(url, options);

        return { status: 'success', data: response.data };
    } catch (error) {
        const errorMessage =
            error && error.response && error.response.data ? error.response.data.message : '';
        return { status: 'error', message: errorMessage };
    }
};
